<script setup lang="ts">
import { SocialMediaPage } from '@/services/pages';

defineProps<{
  isOpen: boolean;
  isAdministrator: boolean;
  expiredPages: SocialMediaPage[],
}>();

const emit = defineEmits(["close", "confirm"]);

const close = () => emit("close");

const confirm = () => {
  emit("confirm");
};
</script>

<template>
  <Dialog class="w-[578px]"
    :isOpen="isOpen"
    @close="close()"
  >
    <template #title>
      {{ $t("pages.adminPanel.categories.social_media_accounts.expired_account_dialog.title") }}
    </template>

    <template #content>
      <p>
        {{ $t("pages.adminPanel.categories.social_media_accounts.expired_account_dialog.explanation") }}
      </p>
      <div class="custom-scrollbar flex flex-auto flex-col gap-2 overflow-auto" role="list">
        <div class="flex gap-2 items-center" role="listitem"
          v-for="page in expiredPages"
          :key="page.id"
          :aria-label="`${page.socialMediaType} ${page.name}`"
        >
          <img
            role="none"
            aria-hidden="true"
            class="h-8 w-8 flex-none rounded-full"
            :src="`/icons/active/${page.socialMediaType.toLowerCase()}.svg`"
            :alt="`icon-${page.socialMediaType}`"
          />
          <div class="text-ppa-dark-blue font-bold">{{ page.name }}</div>
        </div>
      </div>
      <p v-if="isAdministrator">
        {{ $t("pages.adminPanel.categories.social_media_accounts.expired_account_dialog.recommendation_admin") }}
      </p>
      <p v-else>
        {{ $t("pages.adminPanel.categories.social_media_accounts.expired_account_dialog.recommendation_user") }}
      </p>
    </template>

    <template #actions>
      <ButtonComponent
        v-if="isAdministrator"
        @click="close()"
      >
        {{ $t("pages.adminPanel.categories.social_media_accounts.expired_account_dialog.close_button") }}
      </ButtonComponent>
      <ButtonComponent primary
        v-if="isAdministrator"
        @click="confirm()"
      >
        {{ $t("pages.adminPanel.categories.social_media_accounts.expired_account_dialog.restore_button") }}
      </ButtonComponent>
      <ButtonComponent primary
        v-else
        @click="close()"
      >
        {{ $t("general.ok") }}
      </ButtonComponent>
    </template>
  </Dialog>
</template>
